export const production = process.env.REACT_APP_production === 'true';
export const serverUrl = process.env.REACT_APP_serverUrl;
export const defaultLanguage = process.env.REACT_APP_defaultLanguage;
export const supportedLanguages = process.env.REACT_APP_supportedLanguages;
export const googleId = process.env.REACT_APP_googleId;
export const facebookId = process.env.REACT_APP_facebookId;
